import './App.css';
import "./bootstrap-kosmos.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useState, useEffect } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import StyleguideList from './components/styleguidelist.js'
import Styleguide from './components/styleguide.js'
import logo from './logo.png'

function App() {
    const [appName, setAppName] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/api/resources')
            .then((res) => {
                if (!res.ok) throw new Error("Netzwerk-Fehler");
                return res.json();
            })
            .then((data) => {
                setAppName(data.appName);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Fehler beim Laden des App-Namens:", err);
                setAppName("Kosmos Styleguides"); // Fallback, falls die API offline ist
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div className="container p-5 text-center">Lade Anwendung...</div>;
    }


    return (
        <BrowserRouter>
            <div className="App container-fluid p-2">
                <div className="row">
                    <div className="col-md-auto">
                        <img src={logo} className="App-logo" alt="logo"/>
                    </div>
                    <div className="col-md-auto">
                        <h1>{appName}</h1>
                    </div>
                </div>
                <div className="row">
                    <StyleguideList appName={appName}/>
                    <div className="col-md-9" id="detail">
                        <Routes>
                            <Route path="/styleguide/:styleguideId" Component={Styleguide}/>
                        </Routes>
                    </div>
                </div>
            </div>
        </BrowserRouter>
    );
}

export default App;
